import {createSlice} from '@reduxjs/toolkit';
import { validateFields, validateField, validateValue } from './../../../../utilities/validation/validator';
import { regexPatterns } from './../../../../utilities/validation/validationVariables';
import lodash from 'lodash';

const simActivationSlice = createSlice({
    name: 'simActivation',
    initialState: {
        simActivationList: [],
        form: {
            rules: {},
            errors: {}
        },
    },
    reducers: {
        setSimActivationList: (state, action) => {
            if (!action.payload) { return; }


            //build new array from products to simActivationList
            const simActivationList = action.payload.map(function (product, i) {
                const phone = (product.isExistPhone ? product.existPhone : product.newPhone);
                return { 
                    productId: product.productId,
                    index: i,
                    phone: phone,
                    simActivationCode: ''
                }
            });
            state.simActivationList = simActivationList;


            //validation - products
            simActivationList.map(function (product, i) {
                state.form['product_' + i] = product.simActivationCode;
            });


            //validation - rules + errors
            simActivationList.map(function (product, i) {
                state.form.rules['product_' + i] = {
                    required: { value: true, error: 'יש להכניס מספר סים' },
                    pattern: { value: regexPatterns.simActivationCodeRegex, error: 'מספר סים לא תקין' }
                }
                state.form.errors['product_' + i] = '';                
            });

        },   
        changeHandler: (state, action) => {

            state.simActivationList[action.payload.index].simActivationCode = action.payload.value;
            state.form['product_' + action.payload.index] = action.payload.value;

            const error = validateValue(state.form.rules['product_' + action.payload.index], 'product_' + action.payload.index, action.payload.value);
            state.form.errors['product_' + action.payload.index] = error; 
            
            if (error) {
                state.form.valid = false;
            } 
            else {
                state.form.valid = '';
            }
        },
        validateHandler: (state, action) => {
            const form = lodash.cloneDeep(state.form);
            form.valid = '';
            const updatedForm = validateFields(form);
            state.form = updatedForm;
        },
        initValidation: (state, action) => {
            state.form.valid = '';
        },
        

    }
})

export const { setSimActivationList, changeHandler, validateHandler, initValidation } = simActivationSlice.actions
export default simActivationSlice.reducer